import axios from "axios";
import { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WaitlistForm({ variant = "hero" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, { email: email.trim() });
      toast.success("You're on the journey! We'll let you know the moment Hannah's Heart Awakens.");
      setEmail("");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Something went wrong. Please try again.";
      if (err?.response?.status === 409) {
        toast.info(msg);
        setEmail("");
      } else {
        toast.error(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid={`waitlist-form-${variant}`}
      className="flex w-full max-w-md flex-col gap-3 sm:flex-row"
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`waitlist-email-input-${variant}`}
        className="flex-1 rounded-full border border-white/15 bg-white/5 px-6 py-3.5 text-cream placeholder:text-slate-400 outline-none transition-[border-color,box-shadow] duration-300 focus:border-gold focus:shadow-[0_0_20px_rgba(251,191,36,0.35)]"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`waitlist-submit-button-${variant}`}
        className="group inline-flex items-center justify-center gap-2 rounded-full bg-gold px-7 py-3.5 font-medium text-twilight transition-[background-color,transform,box-shadow] duration-300 hover:bg-gold-light hover:shadow-[0_0_25px_rgba(251,191,36,0.55)] active:scale-95 disabled:opacity-70"
      >
        {loading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Send className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
        )}
        Join the Journey
      </button>
    </form>
  );
}
